import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const VisitTypeFilter = ({
    onChange,
    value
}) => {

    const options = [
        { value: '', label: 'All' },
        { value: '1', label: 'Home Visit' },
        { value: '0', label: 'Center Visit' }
    ];

    const [selectedValue, setSelectedValue] = useState(options[0]);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    useEffect(() => {
        const selected = options.find(opt => opt.value === (value || ''));
        if (selected) {
            setSelectedValue(selected);
        }
    }, [value]);

    useEffect(() => {
        if (menuIsOpen) {
            // Prevent scrolling when menu is open
            document.body.style.overflow = 'hidden';
            const reactTableBody = document.querySelector('.rt-tbody');
            if (reactTableBody) {
                reactTableBody.style.overflow = 'hidden';
            }
        } else {
            // Restore scrolling when menu is closed
            document.body.style.overflow = '';
            const reactTableBody = document.querySelector('.rt-tbody');
            if (reactTableBody) {
                reactTableBody.style.overflow = '';
            }
        }

        return () => {
            // Cleanup on unmount
            document.body.style.overflow = '';
            const reactTableBody = document.querySelector('.rt-tbody');
            if (reactTableBody) {
                reactTableBody.style.overflow = '';
            }
        };
    }, [menuIsOpen]);

    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption || options[0]);
        onChange(selectedOption ? selectedOption.value : '');
    }

    return <Select
        onChange={handleChange}
        options={options}
        value={selectedValue}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        styles={{
            control: (provided) => ({
                ...provided,
                minHeight: '40px',
                fontSize: '12px'
            }),
            menu: (provided) => ({
                ...provided,
                maxHeight: '300px',
                overflowY: 'auto',
                zIndex: 9999
            }),
            menuList: (provided) => ({
                ...provided,
                maxHeight: '300px',
                overflowY: 'auto'
            }),
            option: (provided) => ({
                ...provided,
                fontSize: '12px'
            })
        }}
        menuPlacement="auto"
        menuPosition="fixed"
    />
}

export default VisitTypeFilter
